/**
 * Calendar API client
 *
 * Fetches calendar events from the local DB (synced from Google Calendar).
 */

import { fetchApi } from './fetch';

export interface CalendarEvent {
  id: string;
  title: string;
  startTime: string; // ISO datetime
  endTime: string; // ISO datetime
  isAllDay: boolean;
  isDeclined: boolean;
  gcalUrl: string | null;
  isDannyScheduled: boolean;
  taskId: string | null;
  calendarId: string;
}

export interface CalendarEventsResponse {
  events: CalendarEvent[];
}

export async function getTodayCalendarEvents(): Promise<CalendarEvent[]> {
  const today = new Date().toISOString().slice(0, 10);
  const data = await fetchApi<CalendarEventsResponse>(`/calendar/events?date=${today}`);
  return data.events;
}

export interface GoogleIntegrationStatus {
  connected: boolean;
  email?: string;
  plannerEnabled?: boolean;
}

export async function getGoogleIntegrationStatus(): Promise<GoogleIntegrationStatus> {
  try {
    return await fetchApi<GoogleIntegrationStatus>('/integrations/google/status');
  } catch {
    return { connected: false };
  }
}

export async function replanDay(): Promise<{
  queued: boolean;
  tasksScheduled?: number;
  message?: string;
}> {
  return fetchApi('/calendar/replan', { method: 'POST' });
}
